import gql from 'graphql-tag';

export const GET_LAYOUTS = gql`
  query GetLayouts($venueId: ID!) {
    venue: Venue(id: $venueId) {
      id
      company {
        id
        layouts {
          id
          name {
            id
            se
            en
            es
            no
          }
        }
      }
    }
  }
`;

export const GET_POS_DEVICES = gql`
  query GetPosDevices($venueId: ID!, $companyId: ID!) {
    devices: allPOSDevices(filter: { company: { id: $companyId }, venue: { id: $venueId } }) {
      id
      name
      claimed
    }

    venue: Venue(id: $venueId) {
      id
      organizationId
    }
  }
`;
